var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isTechnicallyActive)?_c('hosting-settings',{attrs:{"domain":_vm.domain,"subscription":_vm.subscription}}):_c('div',{staticClass:"page-block__item-wrapper"},[_vm._v(_vm._s(_vm.trans('hosting.no-hosting')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }